import { AuthUser } from "aws-amplify/auth";
import { create } from "zustand";

interface AuthStore {
    user: AuthUser | undefined;
    isUserSet: boolean;
    userEmail: string;
    isAdmin: boolean;
    reset: () => void;
}

const initialState = {
    user: undefined,
    isUserSet: false,
    isAdmin: false,
    userEmail: "",
};

export const useAuthStore = create<AuthStore>((set) => ({
    ...initialState,
    reset: (): void => set({ ...initialState }),
}));
